import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useLocation } from '@reach/router';
import React from 'react';

import { NeighborhoodsMapContent } from 'components/NeighborhoodsMap';
import { ReactComponent as InteractiveCitiesMap } from 'images/interactive_cities_map.svg';
import NeighborhoodsProvider from 'providers/NeighborhoodsProvider';

import cityMap from './cityMap';

const CITY_MAP_VIEWBOX = {
	width: 2389.52,
	height: 1504.15,
};

const CitiesMap = ({
	title = 'Driving Distances From Your Home City',
	useSlider = true,
	defaultIndex = undefined,
	...props
}) => {
	const location = useLocation();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<NeighborhoodsProvider location={location}>
			<NeighborhoodsMapContent
				title={title}
				useSlider={useSlider}
				defaultIndex={defaultIndex}
				className="citiesMap"
				MapComponent={InteractiveCitiesMap}
				viewBox={CITY_MAP_VIEWBOX}
				svgKey="city"
				clampFocusX={!isMobile}
				slideData={cityMap}
				slideKey="key"
				focusPinCount={isMobile ? 10 : 100}
				focusCenterOffset={isMobile ? { x: 0, y: -400 } : { x: 0, y: -400 }}
				minFocusScale={isMobile ? 2 : 1}
				maxFocusScale={isMobile ? 2.25 : 1.25}
				{...props}
			/>
		</NeighborhoodsProvider>
	);
};

export default CitiesMap;